// extracted by mini-css-extract-plugin
module.exports = {"container":"FlexContainerWithTitle_container__iFW6I","title":"FlexContainerWithTitle_title__sKbT7","childrenContainer":"FlexContainerWithTitle_childrenContainer__hIP9W"};